<template>
  <div
    v-view-tracker="analyticsParams"
    class="write-banner"
  >
    <div class="text">
      <div class="title">Вдохновите других на&nbsp;открытия</div>
      <div class="description">Расскажите о своём путешествии с&nbsp;Трипстером</div>
    </div>
    <UiButton
      v-click-tracker="analyticsParams"
      text="Написать статью"
      color-mode="neutral"
      variant="primary"
      :size="buttonSize"
      href="https://author.tripster.ru/?from=article"
      target="_blank"
    />
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { UiButton } from '@experience/vue3-kit';

  import { useClickTracker, useViewTracker } from '@/shared/analytics/tracker';
  import { useScreenSize } from '@/shared/utils/breakpoints';

  interface Props {
    articleId?: number;
  }

  type ButtonSize = 'small' | 'medium';

  const props = defineProps<Props>();
  const { isMobile } = useScreenSize();

  const vViewTracker = useViewTracker('article-page:write-banner.view');
  const vClickTracker = useClickTracker('article-page:write-banner.click');

  const analyticsParams = computed(() => ({
    experience_id: props.articleId || 0,
  }));

  const buttonSize = computed<ButtonSize>(() => {
    return isMobile.value ? 'small' : 'medium';
  });
</script>

<style lang="scss" scoped>
  .write-banner {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    width: 100%;
    max-width: 805px;
    margin-top: 40px;
    padding: 32px;
    border-radius: 16px;
    background-color: var(--alias-color-background-accent-orange-lightest);

    .title {
      @include base-700-500-semi;

      @include mobile {
        @include base-500-400-semi;
      }
    }

    .description {
      margin-top: 4px;

      @include base-500-400-regular;

      @include mobile {
        padding-top: 6px;

        @include base-400-300-regular;
      }
    }

    @include tablet {
      padding: 24px;
    }

    @include mobile {
      padding: 16px;
    }
  }
</style>
